<div [hidden]="!show" class="confirm-station-popup">
    <div class="modal-header">
        Is {{ callsignCookie.value || "this" }} your local station?
        <button type="button" class="btn btn-secondary btn-close" (click)="confirmStation()">
            <app-icon [type]="'X'"></app-icon>
        </button>
    </div>
    <div class="modal-body">
        <button type="button" class="btn btn-primary" (click)="confirmStation()">Yes</button>
        <button type="button" class="btn btn-secondary" (click)="openChooseStationModal()">
            No, Change My Station
        </button>
    </div>
</div>
